
import React from 'react';
import { Button } from '@/components/ui/button';
import { Clock, Target, FileText } from 'lucide-react';
import { PersonaMotif } from '@/components/HomeChallengesSection';

interface AssessmentIntroProps {
  onNext: () => void;
  assessmentType?: 'ia-diagnostic' | 'training-transformation';
}

export const AssessmentIntro: React.FC<AssessmentIntroProps> = ({ 
  onNext, 
  assessmentType = 'ia-diagnostic' 
}) => {
  const config = {
    'ia-diagnostic': {
      title: 'AI Digital Transformation',
      subtitle: 'Découvrez en quelques minutes où en est votre entreprise dans sa transformation',
      features: [
        {
          icon: Clock,
          title: '5 minutes',
          description: 'Une évaluation rapide et complète'
        },
        {
          icon: Target,
          title: '6 dimensions',
          description: 'Une analyse approfondie de votre maturité IA'
        },
        {
          icon: FileText,
          title: 'Rapport détaillé',
          description: 'Résultats et recommandations'
        }
      ]
    },
    'training-transformation': {
      title: 'Diagnostic Transformation Formation IA',
      subtitle: "Évaluez la maturité IA de votre activité formation en 5 minutes",
      features: [
        {
          icon: Clock,
          title: '5 minutes',
          description: 'Une évaluation rapide et complète'
        },
        {
          icon: Target,
          title: '9 dimensions',
          description: 'Stratégie, offre, commercial, organisation, processus, ingénierie, qualité, outils, change'
        },
        {
          icon: FileText,
          title: 'Rapport détaillé',
          description: 'Résultats et recommandations personnalisés'
        }
      ]
    }
  };

  const currentConfig = config[assessmentType];

  return (
    <div className="text-center space-y-8">
      <div>
        <h1 className="text-3xl font-bold mb-4 text-gray-900">
          Diagnostic de maturité
        </h1>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          {currentConfig.subtitle}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8">
        {currentConfig.features.map((feature, index) => (
          <div key={index} className="bg-gray-50 p-6 rounded-lg">
            <div className="flex justify-center mb-4">
              <PersonaMotif icon={feature.icon} tone="orange" size="compact" />
            </div>
            <h3 className="font-semibold text-lg mb-2">{feature.title}</h3>
            <p className="text-gray-600 text-sm">{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        <p className="text-gray-700">
          {assessmentType === 'training-transformation'
            ? "Identifiez vos forces et axes de progression pour intégrer l'IA dans votre stratégie de formation."
            : "Cette évaluation vous permettra d'identifier vos forces et axes d'amélioration pour optimiser votre stratégie IA."}
        </p>
        
        <Button 
          onClick={onNext}
          size="lg"
          className="rounded-full text-white px-8 py-4 font-bold"
          style={{ background: 'linear-gradient(135deg, #D7398B, #FF6600)' }}
        >
          Commencer l'évaluation
        </Button>
      </div>
    </div>
  );
};
